module.exports = __webpack_public_path__ + "static/IBMPlexMono-Regular-6002d09ce81f4a15b9c955d1abbb1f2b.woff";